import { connect } from 'react-redux'
import { required } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'

import { doSaveAndRedirect } from './actions'
import OwnerPageView from './view'

const validators = {
  name: required,
  companyHearAboutUs: required,
}

const initialValues = {
  name: '',
  companyRole: null,
  companyHearAboutUs: null,
  companyHearAboutUsSelect: null,
  companyHearAboutUsText: '',
}

const select = () => ({
  initialValues,
  validators,
})

const perform = {
  onSave: doSaveAndRedirect,
}

export default connect(select, perform)(withFormFields(OwnerPageView))
